var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"footer-email",attrs:{"href":"mailto:mail@teroom.ru"}},[_c('Icon',{staticClass:"footer-email__icon",class:{ green: _vm.greenIcon },attrs:{"name":"mail"}}),_vm._v("mail@teroom.ru")],1)}
var staticRenderFns = []

export { render, staticRenderFns }